import * as types from "./mutation-type";
import api from "@/modules/api";

const actions = {

  async importFile({ commit }, formData) { 
    try {
      commit(types.IMPORT_FILE_BEGIN, formData.id)
      const { data } = await api.process.importFile(formData)
      commit(types.IMPORT_FILE_SUCCESS, data)
    } catch (e) {
      commit(types.IMPORT_FILE_ERROR, e)
    }
  },
  async importScheduleSimple({ commit }, { id, formData }){
    try {
      commit(types.IMPORT_SIMPLE_FILE_BEGIN, id)
      const { data } = await api.process.importScheduleSimple(id, formData)
      commit(types.IMPORT_SIMPLE_FILE_SUCCESS, data)
    } catch (e) {
      commit(types.IMPORT_SIMPLE_FILE_ERROR, e)
    }  
  }
};

export default actions;
